import { jsx as _jsx } from "react/jsx-runtime";
import { ProductCard } from './ProductCard';
export const ProductGrid = ({ products }) => (_jsx("div", { children: products.map((product) => (_jsx(ProductCard, { product: product }, product.id))) }));
